var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools collapse header",attrs:{"data-collapsed":_vm.collapsed},on:{"click":_vm.change}},[_c('button',{attrs:{"title":"Ouvrir / Fermer"}},[_c('svgicon',{attrs:{"name":"sport/games/collapse"}})],1),_c('h3',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }